import ServiceGraphQL from 'src/service/gql-service';
import { getStripeOnboardLink } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

export const GetStripeOnboardLink = () => {
  const params = {
    query: getStripeOnboardLink.QUERY
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.whoami;
    })
    .catch((err) => {
      throw err;
    });
};
